export default {
    methods: {
        format_photo_count(count) {
            const n = count ?? 0;
            return `${n} ${n === 1 ? 'Photo' : 'Photos'}`;
        },
    },
}
